
// get order status for accept and cancel
export const getOrderStatuses = (orderStatusList) => {
  const acceptStatus = orderStatusList.find(
    (status) => status.IsInitial === true && status.IsUnconfirm === false
  );

  const cancelStatus = orderStatusList.find(
    (status) => status.IsCancelable === true
  );

  return { acceptStatus, cancelStatus };
};
